import { PaletteOptions } from "@mui/material";

const palette: PaletteOptions = {
  primary: {
    main: "#1A8199",
    contrastText: "#FFF",
  },
  success: {
    main: "#1B8369",
    contrastText: "#FFF",
  },
  error: {
    main: "#B34C36",
    contrastText: "#FFF",
  },
  info: {
    main: "rgba(0,0,0,0)",
    contrastText: "#000",
  },
};

export default palette;
